import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'shop',
    serviceName: 'graphql',
    query: gql`
      query shop($ids: [String], $for_admin: Int) {
        shop(ids: $ids, for_admin: $for_admin) {
          data {
            type {
              id
            }
            conditions
          }
        }
      }
    `,
  },
  update: {
    name: 'updateShop',
    serviceName: 'shopadmin',
    query: gql`
      mutation updateShop($ids: [String]!, $type_id: String, $conditions: String) {
        updateShop(ids: $ids, type_id: $type_id, conditions: $conditions) {
          messages
        }
      }
    `,
  },
};

export default schema;
